import axios, { type AxiosResponse } from "axios";
import type {
  AuthResponse,
  LoginPayload,
  LogoutResponse,
} from "@/types/authService";
import apiClient from "./apiClient";
import { API_BASE_URL, ENDPOINTS } from "@/config/api.enpoints";
import { LOCALSTORAGE_KEYS } from "@/config";
import { toast } from "react-toastify";

export const loginUser = async (data: LoginPayload): Promise<AuthResponse> => {
  try {
    const res = await apiClient.post(
      `${API_BASE_URL}${ENDPOINTS.AUTH.login}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    // localStorage.setItem("tenantId", res.data.data.tenantId);
    return res.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      toast.error(error.response?.data?.message || "LogIn failed");
      const message = error.response?.data?.message || "LogIn failed";
      throw new Error(message);
    } else {
      toast.error("LogIn failed");
    }
    throw new Error("An unexpected error occurred");
  }
};
export const logoutUser = async (): Promise<LogoutResponse> => {
  try {
    const refreshToken = localStorage.getItem(LOCALSTORAGE_KEYS.refreshToken) || "";
    const res: AxiosResponse<LogoutResponse> = await apiClient.post(
      `${API_BASE_URL}${ENDPOINTS.AUTH.logout}`,
      {
        refreshToken: refreshToken,
      },
    );
    return res.data;
  } catch (error: unknown) {
    throw new Error((error as Error).message || "Logout failed");
  }
};

export const forgotPassword = async (data: {
  email: string; captchaToken: string;
}): Promise<AuthResponse> => {
  try {
    const res = await apiClient.post(
      `${API_BASE_URL}${ENDPOINTS.AUTH.emailVariations}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error: unknown) {
    console.error("Check Email Error:", error);
    if (axios.isAxiosError(error)) {
      const message =
        error.response?.data?.message || "Failed to validate email";
      throw new Error(message);
    }
    throw new Error("An unexpected error occurred");
  }
};

export const ResetPassword = async (data: {
  token: string;
  newPassword: string;
}): Promise<AuthResponse> => {
  try {
    const res = await apiClient.post(
      `${API_BASE_URL}${ENDPOINTS.AUTH.resetPassword}`,
      {
        token: data.token,
        newPassword: data.newPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (error: unknown) {
    console.error("Reset Password Error:", error);
    if (axios.isAxiosError(error)) {
      const message =
        error.response?.data?.message || "Failed to reset password";
      throw new Error(message);
    }
    throw new Error("An unexpected error occurred");
  }
};
